/* SortOptionsRenderer.js */

"use strict";
const _ = require("lodash");
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const ComboBoxControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.ComboBox;

/* global Slick */

class SortOptionsRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("sort-options-veil-gl"); //TODO Setup the root Element
        this._rootElem.component = this._model;
        if (this.model.darkTheme) {
            this._rootElem.classList.add("dark");
        }
        this._fieldsDropdown = [];
        // this._confirmButton = new ButtonControl({
        //     label: "Confirm",
        //     darkTheme: this.model.darkTheme
        // });

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: this.model.darkTheme
        });

        this._confirmButton = new ButtonControl({
            label: "OK",
            darkTheme: this.model.darkTheme
        });

        // this._resetBtn = new ButtonControl({
        //     label: "Reset",
        //     darkTheme: this.model.darkTheme
        // });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._contentContainer = document.createElement("div");
        this._contentContainer.classList.add("content-container");

        this._buttonContainer = document.createElement("button-container");

        this._msgComponent = document.createElement("msg");

        this._slickTableContainer = document.createElement("sort-options-table");
        this._slickTable = undefined;

        this._columns = [
            {
                id: "order",
                width: 30,
                name: "",
                //field: "order",
                behavior: "selectAndMove",
                asyncPostRender: function (node) {
                    node[0].setAttribute("title", "Reorder");
                },
                selectable: false,
                resizable: false,
                cssClass: "cell-reorder dnd centered g-icon-drag"
            },
            {
                id: "field",
                width: 620,
                name: "Field",
                field: "field",
                toolTip: "field"
            },
            {
                id: "sortType",
                width: 110,
                name: "Sort type",
                field: "sortType",
                toolTip: "Sort type"
            }
        ];
        this._tableOptions = {
            editable: false,
            enableCellNavigation: true,
            enableAsyncPostRender: true,
            forceFitColumns: true,
            autoHeight: true,
            autoEdit: false,
            resizable: false,
            rowHeight: 40
        };

        this._fieldList = [];

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._confirmButton.on("UserClick", (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this)));
        this._cancelButton.on("UserClick", (this._onCancelButtonClick = this._onCancelButtonClick.bind(this)));
        // this._resetBtn.on(
        //     "UserClick",
        //     (this._onResetButtonClick = this._onResetButtonClick.bind(this))
        // );
    }

    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        // this._resetBtn.removeAllListeners("UserClick");
    }

    _registerFieldOptionListeners() {
        this._fieldsDropdown.forEach((dropdown, idx) => {
            dropdown.on("UserValue", (val) => {
                // console.log(val);
                // console.log(arguments);
                this._onFieldSelected(val, idx);
            });
        });
    }

    _unRegisterFieldOptionListeners() {}

    _onConfirmButtonClick() {
        this._callSave();
    }

    _onCancelButtonClick() {
        this._callCancel();
    }

    _onResetButtonClick() {
        this._model._updatedSortData = Object.assign({}, this._model._sortData);
        this._setSortValues(true);
    }
    _onSchedClick() {
        this._msgComponent.innerHTML = "";
    }

    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            this._callStartCapture();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown()
            // this._resetBtn.shutdown()
        ];

        return Promise.all(promArr).then(
            () => {
                this._confirmButton = undefined;
                this._cancel = undefined;
                this._resetBtn = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._msgComponent = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._model = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "SortOptionsRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                // let renderPromises = [
                //     this._scheduleComponent.renderer.render(),
                //     this._notificationsComponent.renderer.render()
                // ];
                return Promise.all([])
                    .then(() => {
                        this._rootElem.appendChild(this._titleComponent);
                        this._rootElem.appendChild(this._slickTableContainer);
                        // this._rootElem.appendChild(this._contentContainer);
                        this._rootElem.appendChild(this._buttonContainer);
                        this._rootElem.appendChild(this._msgComponent);

                        this._slickDataVIew = new Slick.Data.DataView();
                        this._slickDataVIew.setItems(this._model._dataForSlick);
                        this._slickTable = new Slick.Grid(this._slickTableContainer, this._slickDataVIew, this._columns, this._tableOptions);
                        this._slickTable.setSelectionModel(new Slick.RowSelectionModel());
                        this._registerRowMovePlugin(this._slickTable, this._slickDataVIew);

                        // this._buttonContainer.appendChild(this._resetBtn.renderer.rootElement);
                        this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                        this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);

                        return Promise.resolve();
                    })
                    .then(() => {
                        const rowHeader = document.createElement("div");
                        rowHeader.classList.add("sort-option-row");
                        rowHeader.innerHTML = `
                        <div class="sort-order">Order</div>
                        <div class="field-options">Field name</div>
                    `;
                        this._contentContainer.appendChild(rowHeader);
                        return this._renderOptions();
                    })
                    .then(() => {
                        this._registerFieldOptionListeners();
                        return Promise.resolve();
                    });
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _enableComfirmButtons(enable) {
        this._confirmButton.disabled = !enable;
    }

    _renderOptions() {
        return Promise.resolve().then(() => {
            const fieldsList = [...new Set(this._model.getFieldValues())]; // Get distinct values
            console.log(fieldsList);
            const fieldsWithSort = Object.keys(this._model._sortData);
            if (fieldsWithSort.length > 0) {
                fieldsWithSort.forEach((sort) => {
                    this._contentContainer.appendChild(this._createRow(sort));
                });
            }
            // noofrows
            // sortRows = 4 = noofrows
            // sortrows < 4 and fieldscount <= 4, nofrows = largerof sortRows and fieldsCount
            // sortRows < 4 and fieldscoun > 4, noofrows = 4
            let noOfRows = 0;
            if (fieldsWithSort.length === 4) {
                noOfRows = 4;
            } else if (fieldsList.length >= 4) {
                noOfRows = 4;
            } else if (fieldsList.length > fieldsWithSort.length || fieldsList.length === fieldsWithSort.length) {
                noOfRows = fieldsList.length;
            }
            this._rowCount = noOfRows;
            if (fieldsWithSort.length < 4) {
                for (let i = fieldsWithSort.length; i < noOfRows; i++) {
                    this._contentContainer.appendChild(this._createRow(i));
                }
            }

            this._setSortValues();
            // this._contentContainer.innerHTML = innerHtml;
            return Promise.resolve();
        });
    }

    _createRow(sortorder) {
        const sortEl = document.createElement("div");
        sortEl.classList.add("sort-order");
        sortEl.innerText = sortorder;

        const fieldEl = this._createCombobox(sortorder);
        this._fieldList[sortorder] = this._model.getFieldValues();
        this._selectOptions = this._getSelectOptions(this._fieldList[sortorder]);
        fieldEl.setOptions(this._selectOptions);

        const fieldContainer = document.createElement("div");
        fieldContainer.classList.add("field-options");
        fieldContainer.appendChild(fieldEl.renderer.rootElement);

        const rowEl = document.createElement("div");
        rowEl.classList.add("sort-option-row");
        rowEl.appendChild(sortEl);
        rowEl.appendChild(fieldContainer);
        return rowEl;
    }

    _createCombobox(id) {
        this._fieldsDropdown[id] = new ComboBoxControl({
            options: [],
            showFilter: false,
            disabled: false
        });
        return this._fieldsDropdown[id];
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onValidationStateChanged(isValid) {
        this._enableComfirmButtons(isValid);
    }

    _onFieldSelected(val, idx) {
        // console.log(val, idx);
        this._model._updatedSortData[idx] = val;
        this._setSortValues(val, idx);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _callSave() {
        // console.log(this._slickTable);
        // console.log(this._model._slickData);
        /*const updatedData =*/ this._model.getUpdatedSlickData(this._slickTable.getData().getItems());

        this._model.save(this._model._slickData);
    }

    _callCancel() {
        this._model.cancel({ userRejected: true });
    }

    _getSelectOptions(fields) {
        if (!fields) {
            return [];
        }
        return fields.map((field) => {
            return {
                label: field,
                value: field
            };
        });
    }

    _setSortValues(reset = false) {
        for (let i = 0; i < this._rowCount; i++) {
            this._fieldList[i] = this._model.getFieldValues();
            this._fieldsDropdown[i].setOptions(this._getSelectOptions(this._fieldList[i]));
            if (reset) {
                this._fieldsDropdown[i].setValue(undefined);
            }
        }
        for (let key in this._model._updatedSortData) {
            // is sort order which is also the index of combobox
            this._fieldsDropdown[key].setSelectedOption(this._model._updatedSortData[key]);
            this._removeOptionFromOthers(this._model._updatedSortData[key], key);
        }
    }

    _removeOptionFromOthers(val, idx) {
        if (typeof idx !== "number") {
            idx = parseInt(idx, 10);
        }
        for (let i = 0; i < this._rowCount; i++) {
            if (i !== idx) {
                this._fieldList[i] = this._fieldList[i].filter((item) => {
                    if (item === val) {
                        return false;
                    }
                    return true;
                });
                // console.log(i, idx);
                this._fieldsDropdown[i].setOptions(this._getSelectOptions(this._fieldList[i]));
            }
        }
    }

    _registerRowMovePlugin(grid, dataView) {
        const moveRowsPlugin = new Slick.RowMoveManager({
            cancelEditOnDrag: true
        });
        // const sortingComparator = this._model.CustomFieldsEntity.getSortingComparator("order");

        moveRowsPlugin.onBeforeMoveRows.subscribe(function (e, { insertBefore, rows }) {
            rows = [...rows].sort();
            if (
                _.first(rows) === insertBefore ||
                _.last(rows) === insertBefore - 1
                // _.get(dataView.getItem(insertBefore), "inherited")
            ) {
                e.stopPropagation();
                return false;
            }
            return true;
        });
        moveRowsPlugin.onMoveRows.subscribe(function (e, args) {
            let extractedRows = [],
                left,
                right;
            let rows = args.rows;
            let insertBefore = args.insertBefore;
            let data = dataView.getItems();
            left = data.slice(0, insertBefore);
            right = data.slice(insertBefore, data.length);

            rows.sort(function (a, b) {
                return a - b;
            });

            for (let i = 0; i < rows.length; i++) {
                extractedRows.push(data[rows[i]]);
            }

            rows.reverse();

            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];
                if (row < insertBefore) {
                    left.splice(row, 1);
                } else {
                    right.splice(row - insertBefore, 1);
                }
            }

            data = left.concat(extractedRows.concat(right));

            let selectedRows = [];
            for (let i = 0; i < rows.length; i++) {
                selectedRows.push(left.length + i);
            }
            dataView.setItems(data);
            grid.resetActiveCell();
            grid.setSelectedRows(selectedRows);
            grid.invalidateAllRows();
            grid.resizeCanvas();
        });

        grid.registerPlugin(moveRowsPlugin);
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = SortOptionsRenderer;
